/**
 * MachineFleetPage — locked placeholder for the future "Machine Fleet"
 * surface — equipment + sensor registry. Sub-tab under Library.
 * Reachable at `/sops/machine-fleet`.
 */

import { Cpu } from 'lucide-react';
import { LockedFeaturePage } from './LockedFeaturePage';

export function MachineFleetPage() {
  return (
    <LockedFeaturePage
      pageTitle="Machine Fleet (Coming Soon)"
      title="Equipment & sensor registry"
      description="An equipment + sensor registry per operator station — health monitoring, capability tracking, and predictive maintenance signals applied to the gear your operators work with."
      hint="Machine Fleet will track device IDs, firmware versions, calibration history, and the operator-machine pairing that drives KPI attribution. Once live, it ties into the existing Cameras + Stations infrastructure so a low-throughput KPI reading can be cross-referenced against the specific machine the operator was on at the time."
      icon={Cpu}
    />
  );
}

export default MachineFleetPage;
